import Axios from 'axios';
// TODO: use as a final solution for 'empty materials online' Sentry errors
// import * as Sentry from '@sentry/vue';

class CancelToken {
  constructor(initialValue) {
    this.source = initialValue;
  }

  getSource() {
    return this.source;
  }

  setSource(value) {
    this.source = value;
  }

  cancel() {
    this.source.cancel();
  }
}
export const cancelSource = new CancelToken(Axios.CancelToken.source());

export const requestInterceptor = (config) => {
  // eslint-disable-next-line no-param-reassign
  config.cancelToken = cancelSource.token;
  return config;
};

// TODO: use as a final solution for 'empty materials online' Sentry errors
// export const loggerInterceptor = config => config;

export const api = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use(requestInterceptor);
// TODO: use as a final solution for 'empty materials online' Sentry errors
// api.interceptors.request.use(loggerInterceptor);

// TODO: use as a final solution for 'empty materials online' Sentry errors
// api.interceptors.response.use(
//   response => Promise.resolve(response),
//   (error) => {
//     Sentry.captureException(error);
//     return Promise.reject(error);
//   },
// );
